import Vue from 'vue';
import SmartRetailLinks from '@/plugins/graphql/queries/v2/referral/smart-retail-links-by-app.gql';
import { ReferralLinkModel } from '@/helpers/entities/models/ReferralLinkModel';
export default Vue.extend({
    apollo: {
        smartRetailLinks: {
            query: SmartRetailLinks,
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update(data) {
                const smartRetailLinks = data.smartRetailLinksByApp.edges;
                const smartRetailLinksNode = (retailLink) => {
                    return new ReferralLinkModel(retailLink.node);
                };
                return smartRetailLinks.map(smartRetailLinksNode);
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            smartRetailLinks: [],
        };
    },
    computed: {
        dataForCsv() {
            const self = this;
            if (self.smartRetailLinks.length >= 1) {
                return self.smartRetailLinks.map((retailLink) => {
                    return {
                        id: retailLink.id,
                        name: retailLink.name,
                        salesChannel: retailLink.humanizedSalesChannel,
                        code: retailLink.code,
                        dateCreated: retailLink.formattedCreatedAt,
                        clicks: retailLink.numberOfVisits,
                        referredOrdersCount: retailLink.referredOrdersCount,
                    };
                });
            }
            return [];
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                smartRetailLinks: self.dataForCsv,
            });
        }
    },
});
